import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-evidencias',
  templateUrl: './evidencias.component.html',
  styleUrls: ['./evidencias.component.scss']
})
export class EvidenciasComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
